module.exports = __webpack_public_path__ + "static/may-3-1758ef0f049f02c91e33abf3292673dc.png";